export default "__VITE_ASSET__CkjQ2fRo__"